import React from 'react';

import { PortalConfigContext } from 'src/context';
import { useAppSelector } from 'src/hooks/useStore';
import { resolveFont } from 'src/utils/FontUtils';

export const FontProvider: React.FC = () => {
  const portalConfig = React.useContext(PortalConfigContext);
  const isClient = useAppSelector((state) => state.user.isClient);
  // Only run effect if brand config is present
  React.useEffect(() => {
    if (!portalConfig?.brand) return;
    const { fontFamily } = resolveFont(
      portalConfig.brand.clientFontFamily,
      isClient,
    );
    const fontFamilyWithFallbacks = [
      `"${fontFamily}"`,
      '"Helvetica"',
      '"Arial"',
      'sans-serif',
    ].join(',');
    document.documentElement.style.setProperty(
      '--font-primary',
      fontFamilyWithFallbacks,
    );
  }, [portalConfig?.brand?.clientFontFamily, portalConfig?.brand, isClient]);
  if (!portalConfig?.brand) return null;
  return null;
};
